import { CatalogObjectDisplayObject } from './CatalogObjectDisplayObject';

export interface ICollectionToShow {
  id: number;
  name: string;
  objectNumber: number;
  objects: CatalogObjectDisplayObject[];
}

export class CollectionToShow implements ICollectionToShow {
  id: number = 0;
  name: string = '';
  objectNumber: number = 0;
  objects : CatalogObjectDisplayObject[] = [];
}
